import { PAYING_CUSTOMER_MOVEMENTS_SERIES } from "./exampleData";
import { CHART_NEGATIVE, CHART_POSITIVE } from "./chartTheme";
import StackedMovementsChart, { type MovementSeries } from "./StackedMovementsChart";

/** New paying accounts stack up, churned stack down — the app's stacked view. */
const SERIES: MovementSeries[] = [
  { key: "new", name: "New", color: CHART_POSITIVE },
  { key: "churned", name: "Churned", color: CHART_NEGATIVE },
];

/**
 * Paying customers movements over time — new paying accounts above the zero line,
 * churned below, with a net-change line. Matches the app's stacked view (New up,
 * Churned down, Net Change line); reactivation lives in the supporting table.
 */
const PayingCustomerMovementsChart = () => (
  <StackedMovementsChart
    caption="New paying accounts stack above the zero line each month, churned accounts below, and the line is net change. Counts show how widespread a movement is, where dollars only show its size."
    data={PAYING_CUSTOMER_MOVEMENTS_SERIES}
    series={SERIES}
    netKey="net"
    netName="Net change"
    format={(v) => `${v}`}
    yWidth={32}
  />
);

export default PayingCustomerMovementsChart;
